const MARKETPLACE_HOSTS = new Set(['app', 'app-dev', 'www', 'localhost'])

const getHostnameSlug = (): string | null => {
  const first = window.location.hostname.split('.')[0]
  return first || null
}

/** Hostname principal (marketplace) — `app.atacante.com.br`, `app-dev`, etc. */
export const isMarketplaceHostname = (): boolean => {
  const slug = getHostnameSlug()
  return !slug || MARKETPLACE_HOSTS.has(slug)
}

/** Slug da branch quando o hostname é um subdomínio dedicado a uma loja. */
export const getBranchSlugFromHostname = (): string | null => {
  if (isMarketplaceHostname()) {
    return null
  }
  return getHostnameSlug()
}

export const getBranchSlugFromPathname = (pathname: string): string | null => {
  const match = pathname.match(/^\/unidade\/([^/]+)/)
  return match?.[1] ?? null
}

/**
 * Rota do "Início" no header/menu.
 *
 * Em ambos os cenários (marketplace e subdomínio de branch) o destino é `/` —
 * a decisão de qual componente renderizar fica em `RootRoute`.
 */
export const useHomePath = (): string => '/'
